<card>
    <div class="card-header-content">
        <h1>{{ wording.filters }}</h1>
    </div>
    <div class="card-body-content" *ngIf="filterFormGroup">
        <div *ngFor="let controlName of filterDataKeys; let odd = odd;"
             class="filter-container" [ngClass]="{odd: odd}">
            <header class="flex" (click)="toggleFilterfield(controlName)">
                {{filterConfig[controlName].filterLabel}}
                <fa-icon [icon]="filterConfig[controlName].show ? iconAngleUp : iconAngleDown"></fa-icon>
            </header>
            <div *ngIf="filterConfig[controlName].show" class="fields">
                <div *ngFor="let controlKey of getFormControlKeys(controlName);">
                    <span>
                        <label class="segment-label"
                               *ngIf="getFormControlKeys(controlName).length > 1">
                            {{ getSegmentLabel(controlKey) }}
                        </label>
                        <span *ngIf="filterConfig[controlName].type === 'slider'"
                            [innerHTML]="getRangeLabel(controlName, controlKey)"></span>

                    </span>
                    <multi-checkbox *ngIf="filterConfig[controlName].type === 'checkbox'"
                                    [fieldConfig]="getCheckboxFieldConfig(filterFormGroup.get(controlName), controlKey)"
                                    [options]="fieldsOptions[controlName][controlKey]">
                    </multi-checkbox>
                    <slider-field *ngIf="filterConfig[controlName].type === 'slider'"
                                  [fieldConfig]="getSliderFieldConfig(filterFormGroup.get(controlName), controlKey)">
                    </slider-field>
                </div>
            </div>
        </div>
    </div>
</card>